(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("examValidation", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/account/exam/examValidationView.html",
            controller: ["authService", "takeExamResource", "messageService", "$state", "$rootScope", "$interval", "$scope", ExamValidationCtrl],
            controllerAs: "vm"
        };
        function ExamValidationCtrl(authService, takeExamResource, messageService, $state, $rootScope, $interval, $scope) {
            var vm = this;
            $scope.$on('$destroy', function () {
                if (vm.cancelInterval)
                    $interval.cancel(vm.cancelInterval);
            });
            vm.assignmentId = $state.params.assignmentId;
            if (!vm.assignmentId) {
                $state.go("main.learningPlan");
                return;
            }
            vm.proctorValidated = false;
            vm.learnerValidated = false;
            vm.learnerName = authService.authentication.userFirstName + " " + authService.authentication.userLastName;
            vm.validatingLearner = false;
            vm.validatingProctor = false;
            vm.examInfoDataLoaded = false;
            vm.continueExamModel = {};
            takeExamResource.getValidateProctorAndLearnerViewModel({ assignmentId: vm.assignmentId }, function (data) {
                vm.examName = data.itemName;
                vm.examDescription = data.itemDescription;
                vm.isProctored = data.isProctored;
                vm.isScheduled = data.isScheduled;
                vm.isNotScheduled = data.isNotScheduled;
                vm.isPasswordRequired = data.isPasswordRequired;
                vm.isTimed = data.isTimed;
                vm.timeLimit = data.timeLimit;
                vm.viewModelError = data.error;
                vm.dataLoaded = true;
                if (data.error || data.activationCompleted) {
                    if ($rootScope.fromState.name !== "")
                        $state.go($rootScope.fromState.name, $rootScope.fromParams);
                    else
                        $state.go("main.learningPlan");
                }
                if (vm.isProctored && vm.isScheduled) {
                    vm.cancelInterval = $interval(function () {
                        takeExamResource.checkProctor({ assignmentId: vm.assignmentId }, function (result) {
                            if (result.value) {
                                vm.proctorValidated = true;
                                $interval.cancel(vm.cancelInterval);
                            }
                        }, function (errorData) {
                            messageService.error(errorData);
                            $interval.cancel(vm.cancelInterval);
                        });
                    }, 5000);
                }
            }, function (errorData) {
                messageService.error(errorData);
            });
            vm.validateProctor = function () {
                if (vm.proctorValidationForm.$valid) {
                    vm.validatingProctor = true;
                    takeExamResource.validateProctor({ password: vm.proctorPassword, userName: vm.proctorUserName }, function (result) {
                        if (result.value) {
                            vm.continueExamModel.proctorUserName = vm.proctorUserName;
                            vm.continueExamModel.proctorPassword = vm.proctorPassword;
                            vm.proctorValidated = true;
                            vm.proctorUserName = "";
                            vm.showProctorErrors = false;
                        }
                        else {
                            messageService.error("exams.takeExam.validationPage.proctorValidation.failed");
                        }
                        vm.proctorPassword = "";
                        vm.validatingProctor = false;
                    }, function (error) {
                        messageService.error(error);
                        vm.validatingProctor = false;
                    });
                }
                else {
                    vm.proctorValidated = false;
                    vm.showProctorErrors = true;
                }
            };
            vm.validateLearner = function () {
                if (vm.learnerValidationForm.$valid) {
                    vm.validatingLearner = true;
                    takeExamResource.validateLearner({ password: vm.learnerPassword }, function (result) {
                        if (result.value) {
                            vm.continueExamModel.learnerPassword = vm.learnerPassword;
                            vm.learnerValidated = true;
                            vm.showLearnerErrors = false;
                        }
                        else {
                            messageService.error("exams.takeExam.validationPage.learnerValidation.password.invalid");
                        }
                        vm.learnerPassword = "";
                        vm.validatingLearner = false;
                    }, function (error) {
                        messageService.error(error);
                        vm.validatingLearner = false;
                    });
                }
                else {
                    vm.learnerValidated = false;
                    vm.showLearnerErrors = true;
                }
            };
            vm.continueToExam = function () {
                vm.updating = true;
                takeExamResource.createOrUpdateActivationExam({ assignmentId: vm.assignmentId }, vm.continueExamModel, function (data) {
                    if (data.examExpired)
                        $state.go("main.accountExamResult", { examInfo: { examAttemptId: data.examAttemptId, examName: vm.examName, learnerName: vm.learnerName, autoSubmitted: true } });
                    else
                        $state.go("main.accountExamLaunch", { examInfo: { examAttemptId: data.examAttemptId, examName: vm.examName, isTimed: vm.isTimed, timeLimit: vm.timeLimit } });
                }, function (error) {
                    messageService.error(error);
                    vm.updating = false;
                });
            };
            vm.isContinuetoExamEnabled = function () {
                if (vm.updating)
                    return false;
                if (vm.isPasswordRequired && vm.isProctored)
                    return vm.proctorValidated && vm.learnerValidated;
                if (vm.isPasswordRequired)
                    return vm.learnerValidated;
                if (vm.isProctored)
                    return vm.proctorValidated;
                return true;
            };
        }
    });
}());
